import { Pipe, PipeTransform } from '@angular/core';
import { installationDateFromString } from './installation-date.util';

@Pipe({
    name: 'installationDate',
    standalone: true,
    pure: true
})
export class InstallationDatePipe implements PipeTransform {
    transform(
        value: string | null | undefined,
        locale: string = 'en-GB'
    ): string {
        const date = installationDateFromString(value);

        if (!date) {
            return '';
        }

        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(date);
    }
}
